import { authSlice } from '../features/authSlice';
import { combineReducers } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { msgSystemSlice } from '../features/msgSystemSlice';
import { configSlice } from '../features/configSlice';
import { socketSlice } from '../features/socketSlice';
import { persistReducer, persistStore } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'],
};

export const rootReducer = combineReducers({
    auth: authSlice.reducer,
    system: msgSystemSlice.reducer,
    config: configSlice.reducer,
    socket: socketSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false
      }),
  });

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
